import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  title: {
    paddingBottom: theme.spacing(9),
    fontSize: 24,
    lineHeight: '35px',
  },
}));
